import React from 'react';
import { Box, useTheme } from '@mui/material';
import { ConditionalLoader } from 'dashboard409a/pages/Operations/components';
import { StepLabelProps } from './StepLabel.props';
import { StyledStepLabel } from './StepLabel.styles';
import StepIcon from '../StepIcon/StepIcon';
import { StepStatus } from '../ValuationStatusTracker.types';

const CustomStepIcon = ({ status, isLoading }: { status: StepStatus; isLoading: boolean }) => (
  <StepIcon status={status} isLoading={isLoading} />
);

const StepLabel = ({ label, step, index, isLoading, disabled = false, ...rest }: StepLabelProps) => {
  const theme = useTheme();

  const getStepStyles = () => {
    const baseStyles = {
      padding: theme.spacing(0.75),
      borderRadius: theme.shape.borderRadius * 2,
      fontSize: theme.typography.body2.fontSize,
      display: 'inline-block',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.6 : 1,
    };

    switch (step) {
      case StepStatus.COMPLETED:
        return {
          ...baseStyles,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        };

      case StepStatus.ACTIVE:
        return {
          ...baseStyles,
          border: `1px solid ${theme.palette.primary.main}`,
          color: theme.palette.primary.main,
        };

      case StepStatus.PENDING:
        return {
          ...baseStyles,
          backgroundColor: 'transparent',
          color: theme.palette.grey[400],
        };

      default:
        return baseStyles;
    }
  };

  return (
    <StyledStepLabel
      {...rest}
      slots={{ stepIcon: (props: any) => <CustomStepIcon status={step} isLoading={isLoading} {...props} /> }}
      onClick={disabled ? undefined : () => rest.onClick?.()}>
      <ConditionalLoader isLoading={isLoading} width={200}>
        <Box style={getStepStyles()}>{label}</Box>
      </ConditionalLoader>
    </StyledStepLabel>
  );
};

export default StepLabel;
